import { render } from "./Add-offredata.vue?vue&type=template&id=4daf5fff"
import script from "./Add-offredata.vue?vue&type=script&lang=js"
export * from "./Add-offredata.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__